import { type VoucherOption, VoucherOptionValues } from '../types'

export interface VoucherRedemption {
  amountToPay: number
  voucherOption: VoucherOption
}

export function calculateVoucherRedemption(voucherAmount: number, paymentAmount: number): VoucherRedemption {
  if (voucherAmount <= paymentAmount) {
    return { amountToPay: voucherAmount, voucherOption: VoucherOptionValues.FULL }
  }

  return { amountToPay: paymentAmount, voucherOption: VoucherOptionValues.PARTIAL }
}
